export const ROLE = {
  ADMIN: "admin",
  CLIENT: "client",
};

export const ACCESS = {
  DASHBOARD: "dashboard",
  VENDING_MACHINE: "vending_machine",
  INVENTORY: "inventory",
  REPORT: "report",
  MRO: "mro",
  USER: "user",
  MRO_REPORT: "mro_report",
  NOTIFICATIONS: "notifications",
};

export const USER_STATUS = {
  ACTIVE: "active",
  DISABLED: "disabled",
};

export const MACHINE_STATUS = {
  ONLINE: "online",
  OUT_OF_STOCK: "out_of_stock",
  ERROR: "error",
  OFFLINE: "offline",
};
